import { AiScrubScope, AiScrubStreamTokenResponse } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createAiScrubStreamToken: (
  fetchContext: FetchContext,
  awardId: number,
  batchRunId: string,
  accessToken?: string,
  scope?: AiScrubScope,
) => Promise<AiScrubStreamTokenResponse> = (fetchContext, awardId, batchRunId, accessToken, scope = 'awards') =>
  fetch(`${fetchContext.baseUrl}/api/staff/${scope}/${awardId}/ai-scrub-batch/${encodeURIComponent(batchRunId)}/stream-token`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<AiScrubStreamTokenResponse>(fetchContext.errorStore, response, 'create AI scrub stream token'));
